var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"d-flex"},[_c('v-spacer'),_c('v-btn',{staticClass:"mb-2 mr-2",attrs:{"color":"primary"},on:{"click":this.onClick}},[_c('v-icon',[_vm._v("mdi-plus")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }